import { useParams } from 'react-router-dom';
import { Stack, Skeleton } from '@mui/material';

import { InfoModal } from '@src/components';

import { useWebinarAttendees } from './useWebinarAttendees';

import AttendeesHeader from './Components/AttendeesHeader';
import AttendeesFilter from './Components/AttendeesFilter/AttendeesFilter';
import AttendeesCards from './Components/AttendeesCards';
import AttendeesTable from './AttendeesTable/AttendeesTable';
import BulkActionModal from './Components/BulkActionModal/BulkActionModal';

import styles from './webinarAttendees.module.scss';

const WebinarAttendees = () => {
  const { id } = useParams();
  const {
    loading,
    cardInfoData,
    tableRef,
    selectedAttendees,
    setSelectedAttendees,

    isBulkActionOpen,
    setIsBulkActionOpen,
    modalStatus,
    handleAcknowledgeAttendeesByFilter,
    isBulkActionLoading,
    apiFilters,
    setFilters,
    filters,
    SelectAll,
    UnselectAll,
    handleOpenBulkActionModal,
    handleFilterChange,
  } = useWebinarAttendees(id);

  return (
    <>
      <div className={styles['webinar-attends-container']}>
        <AttendeesHeader />
        {loading ? (
          <Stack direction="row" gap={10}>
            {[...Array(4)].map((_, i) => (
              <Skeleton key={i} width="25%" height={150} />
            ))}
          </Stack>
        ) : (
          <AttendeesCards data={cardInfoData} />
        )}

        <div className={styles.horizontalLine} />

        <AttendeesFilter
          filters={filters}
          setFilters={setFilters}
          SelectAll={SelectAll}
          UnselectAll={UnselectAll}
          selectedAttendees={selectedAttendees}
          setSelectedAttendees={setSelectedAttendees}
          handleOpenBulkActionModal={handleOpenBulkActionModal}
          handleFilterChange={handleFilterChange}
        />

        {apiFilters && (
          <AttendeesTable
            filteredAttendees={apiFilters}
            tableRef={tableRef}
            setSelectedAttendees={setSelectedAttendees}
          />
        )}
      </div>
      <BulkActionModal
        isModalOpen={isBulkActionOpen}
        setIsModalOpen={setIsBulkActionOpen}
        handleAcknowledgeAttendeesByFilter={handleAcknowledgeAttendeesByFilter}
        status={modalStatus}
        selectedAttendees={selectedAttendees}
        isBulkActionLoading={isBulkActionLoading}
      />
      <InfoModal />
    </>
  );
};

export default WebinarAttendees;
